<template lang="pug">
label._checkbox(
    :class="{ nonClickable: disabled }",
    :style="{ opacity: disabled ? '.5' : '1' }"
)
    //- input(type="checkbox" :checked='modelValue' @input="e=>{modelValue = e.target.checked;$emit('update:modelValue', e.target.checked)}" :disabled="disabled" :name="name" hidden)
    input(
        type="checkbox",
        :checked="modelValue",
        @input.stop="(e) => { $emit('update:modelValue', e.target.checked); }",
        :disabled="disabled",
        :name="name",
        hidden
    )
    template(v-if="modelValue === null")
        span.svgIcon.material-symbols-outlined(translate="no" aria-hidden="true") indeterminate_check_box
    template(v-else-if="modelValue")
        span.svgIcon.material-symbols-outlined(translate="no" aria-hidden="true") check_box
    template(v-else)
        span.svgIcon.material-symbols-outlined(translate="no" aria-hidden="true") check_box_outline_blank

    div(style="white-space: nowrap")
        slot
</template>
<script setup>
import { ref, onMounted, useSlots } from "vue";
let {
    disabled,
    modelValue = ref(false),
    name,
} = defineProps({
    disabled: Boolean,
    modelValue: {
        type: Boolean,
        default: false,
    },
    name: String,
});

const emit = defineEmits(["update:modelValue"]);
const slots = useSlots();
let hasSlotContent = ref(false);
onMounted(() => {
    hasSlotContent.value = !!slots.default && slots.default().length > 0;
});
</script>
<style lang="less" scoped>
label._checkbox {
    position: relative;
    display: inline-flex;
    align-items: center;
    flex-wrap: nowrap;
    cursor: pointer;
    user-select: none;

    & > div {
        font-size: 1rem;
        font-weight: 300;
        white-space: break-spaces;
    }

    span + div:not(:empty) {
        margin-left: 4px;
    }

    /* Unchecked stays the shared bridge default (@muted, 18px); CHECKED brightens
       to the surrounding text color. The extra span.material-symbols-outlined on
       this selector is load-bearing: a bare `input:checked + *` TIES the global
       bridge rule at (0,2,1) and wins only by bundle order - this outranks it
       deterministically. */
    input:checked + span.material-symbols-outlined {
        color: inherit;
    }

    span.material-symbols-outlined {
        & + * {
            margin-left: 4px;
        }
    }
}
</style>
